import { defineMessages } from 'react-intl';

const translations = {
  page: {
    addressFormSection: {
      title: {
        id: 'addressFormSection.title',
        defaultMessage: 'Address',
        description: 'Title of the address form section',
      },
      button: {
        select: {
          label: {
            id: 'addressFormSection.button.select.label',
            defaultMessage: 'Select address',
            description: 'Label of the select address button in the address form section',
          },
        },
      },
      emptyMessage: {
        id: 'addressFormSection.emptyMessage',
        defaultMessage: 'No address selected',
        description: 'Empty message of the address form section',
      },
    },
    selectAddress: {
      title: {
        id: 'selectAddress.title',
        defaultMessage: 'Select address',
        description: 'Title of the select address drawer',
      },
    },
  },
};

export default defineMessages(translations);
